import axios from 'axios';

import {
    API_BASE_URL
} from '../constants/index';

export default class SupplierContactPersonService {
	static instance;

	static getInstance() {
		if (!SupplierContactPersonService.instance) {
			SupplierContactPersonService.instance = new SupplierContactPersonService();
		}

		return SupplierContactPersonService.instance;
	}

    async list(supplierId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/supplier/${supplierId}/contact_persons`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data.data
    }

    async create(payload){
        const response = await axios.post(`${API_BASE_URL}/supplier/contact_person/add`, payload,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
              },
            }
        );
  
        return response.data.data
    }

    async delete(supplierId, personId){
        const response = await axios.delete(`${API_BASE_URL}/supplier/contact_person/${personId}/delete`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
              },
            }
        );
  
        return response.data?.data || null;
    }
}
